import React, { Component } from 'react';

const STYLE_CONSTS = {
    "background-color" : "grey",
    "padding" : "2%",
}
const STYLES = {
    left : {
        "backgroundColor" : STYLE_CONSTS["background-color"],
        "padding" : STYLE_CONSTS["padding"],
        "marginRight" : "2%",
        // "minHeight" : "800px"
    },
    right : {
        "backgroundColor" : STYLE_CONSTS["background-color"],
        "padding" : STYLE_CONSTS["padding"],
        // "minHeight" : "800px"
    }
}
export default class Layout extends Component { 
    constructor(props){
        super(props)
    }

    render(){
        const paddingValue = "1"
        return(
            <div className="main-container row mt-5 mb-5">
                <div className={`col-md-${paddingValue}`}></div>
                <div id="left-container" className="col-12 col-md-3" style={STYLES.left}>
                    {this.props.leftComponent}
                </div>
                
                <div id="right-container" className="col-12 col-md-7" style={STYLES.right}>
                    {this.props.rightComponent}
                </div>
                <div className={`col-md-${paddingValue}`}></div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Layout.js